import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import WithTooltip from '../WithTooltip/WithTooltip';

import classes from './Hint.module.scss';

function Hint({ text, className, placement }) {
  return (
    <div className={cn(classes.base, className)}>
      <WithTooltip text={text} placement={placement}>
        <div>
          <div className={classes.hint}>?</div>
          <span className={classes.visually_hidden}>hint</span>
        </div>
      </WithTooltip>
    </div>
  );
}

Hint.propTypes = {
  text: PropTypes.any,
  placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  className: PropTypes.string
};

Hint.defaultProps = {
  placement: 'top'
};

export default Hint;
